import t from 'tcomb-form'
import React from 'react'

const noobj = Object.freeze({})

export default class Tuple extends t.form.List {
  getTypes () {
    return this.typeInfo.innerType.meta.types
  }

  addItem = () => {
    const {options: {defaultItemValue}} = this.props
    const value = this.state.value.concat(defaultItemValue || undefined)
    const keys = this.state.keys.concat(this.props.ctx.uidGenerator.next())
    this.onChange(value, keys, this.props.ctx.path.concat(value.length - 1), 'add')
  }

  getItems () {
    const { options, ctx } = this.props
    const types = this.getTypes()
    const auto = this.getAuto()
    const i18n = this.getI18n()
    const config = this.getConfig()
    const templates = this.getTemplates()
    const value = this.state.value

    return value.map((itemValue, i) => {
      const buttons = []
      if (!options.disableRemove) {
        buttons.push({ label: i18n.remove, click: this.removeItem.bind(this, i) })
      }
      if (!options.disableOrder) {
        buttons.push({ label: i18n.up, click: this.moveUpItem.bind(this, i) })
        buttons.push({ label: i18n.down, click: this.moveDownItem.bind(this, i) })
      }
      const type = types[i]
      const propOptions = options.fields && options.fields[i] ? options.fields[i] : noobj

      if (!type) return null

      return {
        input: React.createElement(t.form.getComponent(type, propOptions), {
          ref: this.setChildRefFor(i),
          type,
          options: propOptions,
          value: itemValue,
          onChange: this.onItemChange.bind(this, i),
          ctx: {
            context: ctx.context,
            uidGenerator: ctx.uidGenerator,
            auto,
            config,
            i18n,
            name: ctx.name ? `${ctx.name}[${i}]` : String(i),
            templates,
            path: ctx.path.concat(i)
          }
        }),
        key: this.state.keys[i],
        buttons: buttons
      }
    })
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/Tuple.js